/**
 * 般意（PanBrain）官网 —— 单一事实源（Single Source of Truth）
 *
 * 全站所有涉及事实、数据、资质、链接的内容统一从这里读取，
 * 中文站与英文站应共用同一套事实资产，修改只改这里。
 *
 * 注意：留空（""）的可选字段（如部分检测报告编号、京东店链接）
 * 页面会自动隐藏对应展示位，补到数据后填入即自动上线。
 */

// ============================================================
// 公司与品牌
// ============================================================
export const company = {
  brandCn: "般意",
  brandEn: "PanBrain",
  productName: "般意精力舱",
  fullName: "深圳般意科技有限公司",
  founded: 2019,
  city: "深圳",
  // ICP 备案号（沿用线上已在用的真实备案号）
  icp: "浙ICP备2023041842号-3",
  icpLink: "https://beian.miit.gov.cn/",
  // NMPA 二类医疗器械注册证编号（注册人：深圳般意科技有限公司，广东省药品监督管理局 2025-05-20 批准，有效期至 2030-05-19）
  nmpaCertNo: "粤械注准20252090742",
  // 【TODO-核实】医疗器械网络销售备案号（如适用）
  nmpaOnlineSaleNo: "",
  // 官网标准定义段：llms.txt / 首页 / 百科 / 新闻稿抬头全网一字不差（方案 4.1）
  definition:
    "般意（PanBrain）是 2019 年成立于杭州、现总部位于深圳的非侵入式脑机接口科技公司，由耶鲁大学精神医学博士后姚乃琳创办。核心产品「般意精力舱」是结合 EEG 实时脑电监测与经颅直流电刺激（tDCS）干预的家用脑健康设备，用于日常认知状态管理与睡眠改善，已在全球 30 余个国家和地区销售超过 12,000 台。公司为国家高新技术企业，产品通过 NMPA 二类医疗器械认证及 CE、FCC、SRRC 等国内外检测。",
};

// ============================================================
// 关键事实数据（证据墙/首屏/结构化数据共用）
// ============================================================
export const keyFacts = {
  // 全球累计销量（2025-04 通稿口径）
  unitsSold: "12,000+",
  unitsSoldLabel: "全球累计用户 12,000+",
  countries: "30+",
  sciPapers: 19,
  certifications: 8,
  dailyUse: "17 分钟/天",
  // 100 人 × 4 周 × 20 次使用测试数据——方法学整理中，暂不对外展示（相关区块已隐藏）
  studyImproveRate: "",
  // 天猫旗舰店动态评分（2026-07 实测：综合体验/宝贝质量/物流速度 5.0，服务保障 4.7）
  tmallScore: "5.0",
};

// ============================================================
// 创始人
// ============================================================
export const founder = {
  name: "姚乃琳",
  title: "般意科技创始人",
  education: [
    "耶鲁大学精神医学博士后",
    "香港大学精神医学博士",
    "浙江大学心理学士",
  ],
  sciPapers: 19,
  followers: "全网 500 万关注的脑科学科普者",
  douyin: "抖音 @耶鲁脑科学博士琳子",
  quote:
    "在耶鲁做研究的那些年，我见过太多有效的神经科学技术停在论文里。般意要做的事，是把它们带到普通人的书桌上。",
  // 【TODO-核实】90 秒创始人出镜视频地址（复用抖音"为什么做般意"素材）
  videoUrl: "",
};

// ============================================================
// 检测与认证（方案 3.2 合规修正后的"说人话"表述）
// ============================================================
export const certifications = [
  {
    name: "NMPA 二类医疗器械注册",
    year: 2025,
    plain:
      "产品（经颅直流电刺激仪）已获广东省药品监督管理局二类医疗器械注册，核准适用范围：适用于对脑损伤引起的运动功能障碍、语言障碍（失语症）进行辅助治疗。",
    certNo: "粤械注准20252090742",
    queryUrl: "https://www.nmpa.gov.cn/",
  },
  {
    name: "美国 FCC 电磁兼容检测",
    plain: "产品通过美国 FCC 电磁兼容（EMC）检测，符合在美销售的电磁安全要求。",
    certNo: "",
    queryUrl: "",
  },
  {
    name: "欧盟 CE 认证",
    plain: "产品符合欧盟相关安全与电磁兼容指令要求，获准在欧盟市场销售。",
    certNo: "",
    queryUrl: "",
  },
  {
    name: "SRRC 型号核准",
    plain: "产品无线电发射特性通过国家无线电管理委员会型号核准。",
    certNo: "",
    queryUrl: "",
  },
  {
    name: "SAR 比吸收率检测",
    plain: "产品电磁辐射比吸收率（SAR）经检测符合安全限值要求。",
    certNo: "",
    queryUrl: "",
  },
  {
    name: "GB 国家标准全项检测",
    plain: "产品按 GB 国家标准完成全项检测，各项指标符合标准要求。",
    certNo: "",
    queryUrl: "",
  },
  {
    name: "CMA 资质认定检测",
    plain: "检测报告由获得 CMA 资质认定的检验机构出具，具有法定证明效力。",
    certNo: "",
    queryUrl: "",
  },
  {
    name: "CNAS 认可实验室检测",
    plain: "检测实验室获 CNAS 认可，检测报告获 ilac-MRA 国际互认。",
    certNo: "",
    queryUrl: "",
  },
];

// ============================================================
// 专利（已授权 21 项：发明 19、实用新型 1、外观设计 1，证书扫描件已归档）
// ============================================================
export const patents = [
  { type: "发明专利", name: "一种经颅直流电刺激的干预方法", patentNo: "ZL 2020 1 0727613.0", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "经颅直流电刺激的安全控制方法、装置、终端及介质", patentNo: "ZL 2023 1 0844394.8", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "一种经颅直流电刺激设备的佩戴状态检测方法及装置", patentNo: "ZL 2023 1 0845237.9", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "经颅直流电刺激方法、装置、终端及介质", patentNo: "ZL 2023 1 0849504.X", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "一种基于场景和用户状态的干预刺激模式的确定方法", patentNo: "ZL 2023 1 0852123.7", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "经颅直流电刺激时的干预电流值确定方法、装置及终端", patentNo: "ZL 2023 1 0998768.1", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "一种经颅直流电刺激设备的绑带松紧度调节方法及装置", patentNo: "ZL 2023 1 1008229.5", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "一种基于脑电波动态调节电流强度的干预刺激方法", patentNo: "ZL 2023 1 1180383.0", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "基于终端操作的模式推荐方法、装置、终端及存储介质", patentNo: "ZL 2023 1 1348956.6", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "一种经颅直流电刺激设备的干预刺激模式的评价方法", patentNo: "ZL 2023 1 1349017.3", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "眼部光疗装置的光源调整方法、装置、终端及存储介质", patentNo: "ZL 2023 1 1566141.5", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "经颅交流电设备的刺激效果评估方法、装置、终端及介质", patentNo: "ZL 2023 1 1727032.7", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "一种应用于运动皮层的经颅电刺激装置及其控制方法", patentNo: "ZL 2023 1 1171926.2", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "一种应用于语言皮层的经颅电刺激装置及其控制方法", patentNo: "ZL 2023 1 1176830.5", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "经颅直流电干预刺激效果实时评估方法、装置及终端", patentNo: "ZL 2023 1 1317378.X", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "用于大脑干预刺激的音乐配置方法、装置、终端及介质", patentNo: "ZL 2023 1 1317422.7", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "一种脑刺激调控装置、方法、终端及存储介质", patentNo: "ZL 2023 1 1726775.2", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "经颅交流电刺激设备的控制方法、装置、终端及存储介质", patentNo: "ZL 2023 1 1726853.9", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "发明专利", name: "个性化的脑刺激仪器调控方法、装置、终端及存储介质", patentNo: "ZL 2023 1 1726920.7", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "实用新型", name: "一种头戴设备", patentNo: "ZL 2023 2 1895074.7", queryUrl: "https://epub.cnipa.gov.cn/" },
  { type: "外观设计", name: "理疗头盔", patentNo: "ZL 2022 3 0869737.2", queryUrl: "https://epub.cnipa.gov.cn/" },
];

export const patentStats = {
  invention: 19,
  utility: 1,
  design: 1,
};

// ============================================================
// 创始团队学术论文（19 篇，含 SCI 期刊论文与国际会议论文，
// 姚乃琳博士发表，附影响因子（2024 年版）与 JCR 分区，链接为期刊官方页面）
// ============================================================
export const papers = [
  { year: 2018, title: "Quantitative susceptibility mapping as an indicator of subcortical and limbic iron abnormality in Parkinson's disease with dementia", journal: "NeuroImage: Clinical（IF 3.6，Q2）", pubmedUrl: "https://www.sciencedirect.com/science/article/pii/S2213158218302407" },
  { year: 2018, title: "Cortical abnormalities in bipolar disorder: An MRI analysis of 6503 individuals from the ENIGMA Bipolar Disorder Working Group", journal: "Molecular Psychiatry（IF 10.1，Q1）", pubmedUrl: "https://www.nature.com/articles/mp201773" },
  { year: 2018, title: "Widespread white matter microstructural differences in schizophrenia across 4322 individuals: Results from the ENIGMA Schizophrenia DTI Working Group", journal: "Molecular Psychiatry（IF 10.1，Q1）", pubmedUrl: "https://www.nature.com/articles/mp2017170" },
  { year: 2018, title: "Cortical brain abnormalities in 4474 individuals with schizophrenia and 5098 controls via the ENIGMA consortium", journal: "Biological Psychiatry（IF 9.0，Q1）", pubmedUrl: "https://www.biologicalpsychiatryjournal.com/article/S0006-3223(18)31517-8/fulltext" },
  { year: 2017, title: "Characterizing Structural and Functional Brain Connectivity Changes in African Americans with Schizophrenia and Affective Psychosis", journal: "Biological Psychiatry（IF 9.0，Q1）", pubmedUrl: "https://www.biologicalpsychiatryjournal.com/article/S0006-3223(17)30806-5/abstract" },
  { year: 2017, title: "The Role of Intrinsic Brain Functional Connectivity in Vulnerability and Resilience to Bipolar Disorder", journal: "American Journal of Psychiatry（IF 14.7，Q1）", pubmedUrl: "https://psychiatryonline.org/doi/10.1176/appi.ajp.2017.17010095" },
  { year: 2017, title: "Inferring pathobiology from structural MRI in schizophrenia and bipolar disorder: Modeling head motion and neuroanatomical specificity", journal: "Human Brain Mapping（IF 3.3，Q1）", pubmedUrl: "https://onlinelibrary.wiley.com/doi/epdf/10.1002/hbm.23612" },
  { year: 2017, title: "Epigenetic Age Acceleration Assessed In White-Matter Integrity", journal: "WCPG（世界精神遗传学大会）", pubmedUrl: "https://www.sciencedirect.com/science/article/abs/pii/S0924977X16306034" },
  { year: 2017, title: "Epigenetic Age Acceleration Assessed with Human White-Matter Images", journal: "The Journal of Neuroscience（IF 4.0，Q1）", pubmedUrl: "https://www.jneurosci.org/content/37/18/4735.long" },
  { year: 2017, title: "Shared Genetic Factors Influence Head Motion During MRI and Body Mass Index", journal: "Cerebral Cortex（IF 2.9，Q2）", pubmedUrl: "https://academic.oup.com/cercor/article/27/12/5539/2333951" },
  { year: 2016, title: "Conceptualizing Major Depression", journal: "图书章节", pubmedUrl: "" },
  { year: 2016, title: "Multimodal MRI of the hippocampus in Parkinson's disease with visual hallucinations", journal: "Brain Structure & Function（IF 2.59，Q1）", pubmedUrl: "https://link.springer.com/article/10.1007/s00429-014-0907-5" },
  { year: 2016, title: "Disrupted default mode network connectivity in male adolescents with conduct disorder", journal: "Brain Imaging and Behavior（IF 2.4，Q2）", pubmedUrl: "https://link.springer.com/article/10.1007/s11682-015-9465-6" },
  { year: 2016, title: "Common and Unique Structural Brain Abnormalities in Bipolar Disorder and Schizophrenia: Clinically Classifiable?", journal: "OHBM（国际人脑图谱学会年会）", pubmedUrl: "" },
  { year: 2015, title: "Altered resting hemodynamic activity in Parkinson's disease with visual hallucinations", journal: "OHBM（国际人脑图谱学会年会）", pubmedUrl: "" },
  { year: 2015, title: "Resting activity in visual and corticostriatal pathways in Parkinson's disease with hallucinations", journal: "Parkinsonism & Related Disorders（IF 3.4，Q2）", pubmedUrl: "https://www.prd-journal.com/article/S1353-8020(14)00455-6/abstract" },
  { year: 2015, title: "The Default Mode Network is Disrupted in Parkinson's Disease with Visual Hallucinations", journal: "Human Brain Mapping（IF 3.3，Q1）", pubmedUrl: "https://onlinelibrary.wiley.com/doi/10.1002/hbm.22577" },
  { year: 2015, title: "Altered Hemodynamic Activity in Conduct Disorder: A Resting-State fMRI Investigation", journal: "PLoS One（IF 2.6，Q1）", pubmedUrl: "https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0122750" },
  { year: 2014, title: "MRI Predicts Remission at 1 Year in First-Episode Schizophrenia in Females with Larger Striato-Thalamic Volumes", journal: "Neuropsychobiology（IF 3.1，Q2）", pubmedUrl: "https://karger.com/nps/article-abstract/69/4/243/233666/" },
];

// ============================================================
// 产品研究（100 人试验）——方法学与数据整理中，暂不对外展示，
// 相关页面区块已隐藏，整理完成后恢复并回填真实数据
// ============================================================
export const productStudy = {
  scale: "100 人 × 4 周 × 20 次使用",
  summary: "",
  criteria: "",
  scales: "",
  limitations: "",
  pdfUrl: "",
};

// ============================================================
// 媒体报道（真实报道链接，微信公众号发布）
// ============================================================
export const mediaReports = [
  {
    outlet: "深圳高交会",
    title: "深圳高交会：般意科技脑机接口技术引领创新浪潮",
    url: "https://mp.weixin.qq.com/s/3KCDShFHUS9l7nENtnPwQw",
    year: "",
  },
  {
    outlet: "般意科技官方发布",
    title: "喜报！般意科技荣膺 2024「国家高新技术企业」与「专精特新」殊荣",
    url: "https://mp.weixin.qq.com/s/pMN1najwz0RyYRvqf1Z7bA",
    year: "2024",
  },
  {
    outlet: "般意科技官方发布",
    title: "深圳市人大常委会主任戴运龙带队视察深圳般意科技有限公司，充分肯定公司在脑科学领域的创新成果",
    url: "https://mp.weixin.qq.com/s/RIZt8jZa-ZUnpJfbSx8kSg",
    year: "",
  },
  {
    outlet: "般意科技官方发布",
    title: "般意科技与武汉同济医院达成战略合作：共推非侵入式脑机接口技术，让科技福荫千家万户",
    url: "https://mp.weixin.qq.com/s/y5Ud7pznacGKTb0xy7S5DA",
    year: "",
  },
];

// ============================================================
// 产品（官方价格为 2026-07 天猫「PanBrain智能配饰旗舰店」在售口径）
// ============================================================
export const products = [
  {
    model: "LOTUS 2",
    nickname: "金色能量版",
    position: "情绪与睡眠管理",
    forWhom: "压力大、睡眠不佳，希望改善情绪状态与睡眠质量的人群",
    priceBand: "官方价 ¥8,700",
    route: "/lotus2device",
  },
  {
    model: "LOTUS 2R",
    nickname: "蓝色认知版",
    position: "专注与记忆支持",
    forWhom: "高强度用脑人群，希望支持专注力与记忆表现的人群",
    priceBand: "官方价 ¥8,900",
    route: "/lotus2Rdevice",
  },
  {
    model: "Lume",
    nickname: "光能睡眠仪",
    position: "睡眠管理",
    forWhom: "希望以光照方式改善睡眠节律的人群",
    priceBand: "官方价 ¥2,780",
    route: "/sleep",
  },
  {
    model: "经颅直流电刺激仪",
    nickname: "成年人版 · 二类医疗器械",
    position: "脑损伤引起的运动功能障碍、语言障碍（失语症）的辅助治疗",
    forWhom: "有相应医疗需求、在医务人员指导下使用的人群",
    priceBand: "京东价 ¥18,800",
    route: "",
    buyUrl: "https://item.jd.com/10186808608670.html",
  },
];

// ============================================================
// 购买渠道与售后
// ============================================================
export const purchase = {
  tmallStoreName: "PanBrain智能配饰旗舰店",
  tmallPlatform: "天猫",
  // 现有天猫店铺链接（沿用页脚在用链接，统一加 UTM）
  tmallUrl: "http://e.tb.cn/h.gEW4kkPBhpwM0Kw?tk=wlAu3lQH1Ei",
  utm: "utm_source=official_site",
  // 拼好 UTM 的完整店铺链接（所有"前往天猫官方旗舰店"按钮统一直跳此地址）
  tmallFullUrl:
    "http://e.tb.cn/h.gEW4kkPBhpwM0Kw?tk=wlAu3lQH1Ei&utm_source=official_site",
  // 天猫店铺二维码（src/assets/tmall_qr.png，指向 https://panbrain.tmall.com；
  // 如有商家后台官方二维码可同名替换）
  tmallQrAsset: "tmall_qr.png",
  // 京东店（医疗器械版「经颅直流电刺激仪 成年人版」在售）
  jdUrl: "https://item.jd.com/10186808608670.html",
  afterSale: [
    "7 天无理由退换",
    "1 年保修",
    "顺丰包邮",
    "6v1 定制售后服务",
  ],
  antiFake:
    "请认准天猫「PanBrain智能配饰旗舰店」，其他渠道购买的产品无法享受官方售后服务。",
};

// ============================================================
// 联系方式
// ============================================================
export const contact = {
  phone: "400-686-8960",
  bdEmail: "info@panbrain.com",
  bdReplySla: "我们通常在 2 个工作日内回复",
  weibo: "https://weibo.com/u/2124970203",
  wechatName: "般意",
  douyinName: "cool_brain",
  // 全网统一的 sameAs 链接（结构化数据用）【TODO-核实】补齐 36 氪项目页等
  sameAs: [
    "https://weibo.com/u/2124970203",
    // "【TODO-核实：抖音主页链接】",
    // "【TODO-核实：天猫店铺主页链接】",
    // "【TODO-核实：36 氪项目页链接】",
  ],
};

// ============================================================
// 发展历程（按公司官方时间轴，2026-07 核实）
// ============================================================
export const milestones = [
  { year: "2019", events: ["般意科技成立"] },
  { year: "2020", events: ["成立第一家线下脑健康咨询中心", "获宝樾投资股权融资"] },
  { year: "2021", events: ["启动脑机接口硬件产品研发"] },
  { year: "2022", events: ["般意精力舱一代在中国发布"] },
  { year: "2023", events: ["累计售出超 1 万台设备"] },
  {
    year: "2024",
    events: ["认定为国家高新技术企业", "获深圳市专精特新企业资质"],
  },
  {
    year: "2025",
    events: [
      "获 NMPA 二类医疗器械注册证（粤械注准20252090742）",
      "全球累计销量突破 12,000 台",
      "精力舱 EC2 上市",
    ],
  },
  { year: "2026", events: ["亮相 CES 2026（国际消费电子展）"] },
];

// ============================================================
// 核心团队背景
// ============================================================
export const teamBackgrounds = ["牛津大学", "耶鲁大学", "浙江大学", "中科院", "伦敦国王学院（KCL）"];

// ============================================================
// 安全性与禁忌人群（FAQ/科学页/安全白皮书共用，方案 4.4）
// ============================================================
export const safety = {
  tdcsHistory: "经颅直流电刺激（tDCS）已有约 60 年的研究历史，全球范围内已有 1000 余篇同行评议论文。",
  intensity: "设备工作电流为 1–2mA 的微弱直流电，约为家用血糖仪工作电流的量级。",
  sideEffects: "常见反应为电极接触部位的短暂发红或轻微刺痒，通常在取下设备后短时间内自行消退。",
  contraindications: [
    "未成年人",
    "孕期及哺乳期女性",
    "有癫痫病史或癫痫家族史者",
    "体内植有心脏起搏器或其他电子植入设备者",
    "颅内植有金属器械者",
    "颅骨缺损或头皮破损者",
    "严重心脑血管疾病患者",
  ],
  advice: "使用中如出现不适，请立即停用并咨询客服或医生。本产品不适合所有人，购买前请认真阅读禁忌人群说明。",
};

// ============================================================
// FAQ 问答资产（支持页 + FAQPage 结构化数据共用，方案 4.4 统一口径）
// ============================================================
export const faq = [
  {
    q: "般意精力舱是智商税吗？",
    a: "判断一件产品是否值得信任，可以看三点可验证的事实：第一，创始人姚乃琳是耶鲁大学精神医学博士后，发表过 19 篇学术论文，全部可以在期刊官网查到；第二，产品核心的经颅直流电刺激（tDCS）技术在全球范围内已有 1000 余篇同行评议论文；第三，公司已获 19 项授权发明专利，专利号全部公示，可在国家知识产权局查询。我们同时建议您先查看禁忌人群——它并不适合所有人。",
  },
  {
    q: "经颅电刺激（tDCS）安全吗？",
    a: "tDCS 已有约 60 年的研究历史。设备工作电流仅为 1–2mA 的微弱直流电，最常见的反应是电极接触部位短暂的发红或轻微刺痒，通常取下设备后很快消退。请务必在使用前确认自己不属于禁忌人群（未成年人、孕妇、癫痫病史、心脏起搏器植入者、颅内金属植入者等），完整禁忌列表见本页说明。",
  },
  {
    q: "般意精力舱和几百块的助眠仪有什么区别？",
    a: "机制层级不同。几百元的助眠仪多为 CES 微电流或白噪音方案，本质是「遮噪」或单一刺激；般意精力舱是 EEG 实时脑电监测 + tDCS 神经调节的闭环设备——先读懂你的脑电，再针对性干预。",
  },
  {
    q: "和智能手表、智能戒指（如 Oura）有什么区别？",
    a: "监测与干预的区别。手表和戒指告诉你「没睡好」，精力舱帮你「睡得好」：前者只做数据采集，后者在 EEG 监测的基础上进行 tDCS 干预，形成监测—干预闭环。",
  },
  {
    q: "多久能见效？",
    a: "建议每天使用 17 分钟，并保持连续使用 3–6 周。个体差异客观存在，效果因人而异，请保持合理预期并坚持使用。",
  },
  {
    q: "哪些人不能使用般意精力舱？",
    a: "禁忌人群包括：未成年人；孕期及哺乳期女性；有癫痫病史或癫痫家族史者；体内植有心脏起搏器或其他电子植入设备者；颅内植有金属器械者；颅骨缺损或头皮破损者；严重心脑血管疾病患者。购买前请认真阅读产品说明书中的禁忌症全文。",
  },
  {
    q: "金色能量版（LOTUS 2）和蓝色认知版（LOTUS 2R）怎么选？",
    a: "想改善情绪状态和睡眠，选金色能量版 LOTUS 2；想支持专注力和记忆表现，选蓝色认知版 LOTUS 2R。不确定时，可以先做官网的在线测评，或联系客服获得建议。",
  },
  {
    q: "在哪里买才是正品？",
    a: "天猫「PanBrain智能配饰旗舰店」是官方店铺，官网「购买指引」页可跳转验证。通过其他渠道购买的产品无法享受官方售后服务，请认准官方渠道。",
  },
  {
    q: "般意公司靠谱吗？",
    a: "般意科技 2019 年成立于杭州，现总部位于深圳，是国家高新技术企业、深圳市专精特新企业，产品获 NMPA 二类医疗器械注册，全球累计销量超过 12,000 台，销往 30 余个国家和地区，2020 年获宝樾投资股权融资。以上信息均可通过国家企业信用信息公示系统等公开渠道核实。",
  },
  {
    q: "有没有副作用？",
    a: "最常见的是电极接触部位短暂发红或轻微刺痒，属于可逆的轻微反应，通常在取下设备后短时间内自行消退。使用中如出现不适，请立即停用并咨询客服或医生。",
  },
  {
    q: "每天需要用多久？使用复杂吗？",
    a: "每天 17 分钟。佩戴设备后通过 App 启动即可，设备会先进行脑电采集，再按方案自动完成干预，过程中可以闭目休息。",
  },
  {
    q: "设备需要配合手机 App 使用吗？",
    a: "需要。App 用于启动干预方案、查看脑电数据和使用记录。iOS 与 Android 版本均可在官网「App 下载」页获取。",
  },
  {
    q: "退换货和保修政策是什么？",
    a: "官方渠道购买享受 7 天无理由退换、1 年保修、顺丰包邮，并有 6v1 定制售后服务团队提供使用指导。",
  },
  {
    q: "未成年人可以用吗？",
    a: "不可以。未成年人属于禁忌人群，请勿购买给未成年人使用。",
  },
  {
    q: "孕妇可以使用吗？",
    a: "不可以。孕期及哺乳期女性属于禁忌人群。",
  },
  {
    q: "它能治疗失眠、焦虑或抑郁症吗？",
    a: "本产品是按 NMPA 二类医疗器械注册证核准的适用范围使用的设备，核准范围以外的功效描述我们不做宣称。失眠、焦虑、抑郁属于疾病范畴，请先咨询医生，本产品不能替代医疗诊断与治疗。",
  },
  {
    q: "电极会耗电吗？耗材需要更换吗？",
    a: "设备为可充电设计。电极等易耗配件的更换周期与购买方式，请咨询天猫旗舰店客服，以官方说明为准。",
  },
  {
    q: "如何验证我买到的是正品？",
    a: "通过天猫「PanBrain智能配饰旗舰店」购买即为官方正品。如对已有产品的真伪有疑问，可联系官方客服 400-686-8960 核实。",
  },
  {
    q: "老年人可以用吗？",
    a: "不属于禁忌人群的老年人可以使用，建议首次使用时有家人陪同，并严格按照说明书操作。如有基础疾病或正在服药，请先咨询医生。",
  },
  {
    q: "商务合作或投融资洽谈怎么联系？",
    a: "请发送邮件至 info@panbrain.com（深圳般意科技有限公司），我们通常在 2 个工作日内回复。",
  },
];

// ============================================================
// 技术叙事（EEG + tDCS 机制差异化，全站统一口径）
// ============================================================
export const tech = {
  oneLiner: "EEG 监测 + tDCS 干预：先读懂你的脑电，再针对性干预",
  mechanism: ["电极", "微电流", "前额叶皮层", "神经可塑性"],
  dailyUse: "17 分钟/天",
  // EEG 数据库规模（内部口径，2026-07 确认）
  eegDatabase: "10 万+ EEG 脑电数据积累（内部口径）",
  algorithmHistory: "EC1 → EC2 算法迭代",
};



// WEBPACK FOOTER //
// ./src/data/facts.js